/**
 * Print Media (Newspaper / Magazine): DiscountedPrice × insertions.
 */
export function calculatePrintMediaTotal(variant, selection) {
  const discountedPrice = Number(variant?.DiscountedPrice) || 0;
  const units = Number(selection?.unitsToBebought) || 1;
  return discountedPrice * units;
}
